/**
 * @generated SignedSource<<6a0d82f752e525b21feacd93373a0369>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type InternJobsTimeSeriesChartQuery$variables = {
  brandId?: string | null;
  granularity: string;
  hours: number;
  taskName?: string | null;
};
export type InternJobsTimeSeriesChartQuery$data = {
  readonly internJobTimeSeries: ReadonlyArray<{
    readonly failureCount: number;
    readonly runningCount: number;
    readonly successCount: number;
    readonly successRate: number;
    readonly timestamp: string;
    readonly totalJobs: number;
  }>;
};
export type InternJobsTimeSeriesChartQuery = {
  response: InternJobsTimeSeriesChartQuery$data;
  variables: InternJobsTimeSeriesChartQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "brandId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "granularity"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hours"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "taskName"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "brandId",
        "variableName": "brandId"
      },
      {
        "kind": "Variable",
        "name": "granularity",
        "variableName": "granularity"
      },
      {
        "kind": "Variable",
        "name": "hours",
        "variableName": "hours"
      },
      {
        "kind": "Variable",
        "name": "taskName",
        "variableName": "taskName"
      }
    ],
    "concreteType": "JobTimeSeriesBucket",
    "kind": "LinkedField",
    "name": "internJobTimeSeries",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "timestamp",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalJobs",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "successCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "failureCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "runningCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "successRate",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "InternJobsTimeSeriesChartQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "InternJobsTimeSeriesChartQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "d8987e45bc2859dc8dfdc2e35d7ed01a",
    "id": null,
    "metadata": {},
    "name": "InternJobsTimeSeriesChartQuery",
    "operationKind": "query",
    "text": "query InternJobsTimeSeriesChartQuery(\n  $brandId: String\n  $taskName: String\n  $hours: Int!\n  $granularity: String!\n) {\n  internJobTimeSeries(brandId: $brandId, taskName: $taskName, hours: $hours, granularity: $granularity) {\n    timestamp\n    totalJobs\n    successCount\n    failureCount\n    runningCount\n    successRate\n  }\n}\n"
  }
};
})();

(node as any).hash = "5a486ef53fc29b7786dd3e7c1500b90b";

export default node;
